// extracted by mini-css-extract-plugin
export default {"ace-c-cp-ranking-item--highlighted":"cp-ranking-item--highlighted---012ba7af"};